import React, { Component } from "react";

import OlMap from "ol/Map";
import {
  Tile as TileLayer,
  Vector as VectorLayer,
  Image as ImageLayer,
} from "ol/layer";
import { OSM, Vector } from "ol/source";
import { defaults as defaultControls } from "ol/control.js";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom,
} from "ol/interaction.js";
import OlView from "ol/View";
import { fromLonLat } from "ol/proj";
import { LineString, MultiPoint, Point } from "ol/geom";
import Feature from "ol/Feature";
// import { Vector as VectorLayer } from "ol/layer.js";
import VectorSource from "ol/source/Vector";
import { Fill, Style, Stroke, Circle } from "ol/style";

export class MapVoyage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [parseFloat(118.15), parseFloat(-3.1)],
      zoom: parseFloat(4),
      lonLat: [],
    };
  }

  componentDidMount = () => {
    this.olmap = new OlMap({
      target: null,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      controls: defaultControls({
        attributionOptions: { collapsible: true },
      }).extend([
        // overviewMapControl,
        // scaleLineControl
      ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      view: new OlView({
        center: fromLonLat(this.state.center),
        zoom: this.state.zoom,
      }),
    });
    this.olmap.setTarget(`map${this.props.voyageName}`);
    this.props.data.map((item) => {
      this.state.lonLat.push(
        fromLonLat([parseFloat(item[0]), parseFloat(item[1])])
      );
    });
    const featureLine = new Feature({
      geometry: new LineString(this.state.lonLat),
    });
    const sourceLine = new Vector({
      features: [featureLine],
    });
    const vectorLine = new VectorLayer({
      source: sourceLine,
      style: new Style({
        fill: new Fill({
          color: "#076cb0",
        }),
        stroke: new Stroke({
          color: "rgb(7, 108, 176)",
          lineDash: [3, 3],
          width: 2,
        }),
      }),
    });
    // vectorLine.getSource().on("addfeature", (e) => {
    //   this.olmap.getView().fit(vectorLine.getSource().getExtent());
    //   // if (this.props.type === "Point") {
    //   //   this.olmap.getView().setZoom(14);
    //   // }
    // });
    this.olmap.getView().fit(sourceLine.getExtent());
    this.olmap.addLayer(vectorLine);
    const vectorPoint = new VectorLayer({});
    for (let index = 0; index < this.props.data.length; index++) {
      const featurePoint = new Feature({
        geometry: new Point(
          fromLonLat([
            parseFloat(this.props.data[index][0]),
            parseFloat(this.props.data[index][1]),
          ])
        ),
      });
      const sourcePoint = new Vector({
        features: [featurePoint],
      });
      const image = new Circle({
        radius: 5,
        fill: new Fill({
          color:
            this.props.data[index][3] / 10 < 5
              ? "rgba(247, 236, 111, 1)"
              : "rgb(26,5,243)",
        }),
        stroke: new Stroke({
          color:
            this.props.data[index][3] / 10 < 5
              ? "rgb(230, 212, 14)"
              : "rgb(26,5,243)",
          width: 1,
        }),
      });
      const vectorPoint = new VectorLayer({
        source: sourcePoint,
        style: new Style({
          image: image,
        }),
      });
      this.olmap.addLayer(vectorPoint);
    }
  };
  render() {
    return <div id={`map${this.props.voyageName}`} style={{ height: 200 }} />;
  }
}

export default MapVoyage;
